export const environment = {
  production: true,
  apiBasePath: location.protocol + '//' + location.hostname + '/admin/api',
  igvBasePath: location.protocol + '//' + location.hostname + '/static/study_data/Genomic/samples',
};
